import { render, staticRenderFns } from "./u-btn-hamburger-basic.vue?vue&type=template&id=55b09d61&scoped=true"
import script from "./u-btn-hamburger-basic.vue?vue&type=script&lang=js"
export * from "./u-btn-hamburger-basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b09d61",
  null
  
)

export default component.exports